import React, { Component } from 'react';
import { Container,Form, Col, Table, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

import { AdminNav, Loading } from '../../helpers';

import './styleTable.css'

class CheckWeight extends Component {
  
}

export default withRouter(CheckWeight);
